export default __webpack_public_path__ + "static/media/arrowr.1339747f.svg";